let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bAJKw")).then(() => parcelRequire('bDFBW'));